import { loginRequest, msalInstance } from '@modules/msal/MSAL'
import { SBAsyncSelectProvider } from '@supplement-bacon/react-async-select'
import { customSetupAxios } from '@supplement-bacon/react-toolkit/utils'
import { SBRM } from '@supplement-bacon/sbrm-react'
import '@supplement-bacon/sbrm-react/index.css'
import { generateConfig } from '@utils/Entities'
import { useAppDispatch } from '@utils/hooks'
import { App as AntdApp } from 'antd'
import axios from 'axios'
import { Outlet } from 'react-router-dom'

export const DEFAULT_SUCCESS = 'Requête complétée avec succès !'
export const DEFAULT_ERROR =
  'Une erreur est survenue. Veuillez réessayer plus tard'

function App() {
  const dispatch = useAppDispatch()
  const { message } = AntdApp.useApp()

  const config = dispatch(generateConfig())

  /**
   * Inject interceptors for axios.
   * We use the local one instead of the one provided in react-toolkit as the token is gotten from MSAL here.
   *
   * @see https://github.com/axios/axios#interceptors
   */
  customSetupAxios(
    axios,
    async () => {
      const account = msalInstance.getActiveAccount()
      if (!account) {
        console.error(
          'No active account! Verify a user has been signed in and setActiveAccount has been called.'
        )
        window.location.href = '/login'
      }

      const response = await msalInstance.acquireTokenSilent({
        ...loginRequest,
        account: account ?? undefined,
      })

      return response.idToken
    },
    async () => {
      const account = msalInstance.getActiveAccount()
      if (!account) {
        console.error(
          'No active account! Verify a user has been signed in and setActiveAccount has been called.'
        )
        window.location.href = '/login'
      }

      // Launch a SSO redirection to get a new token
      msalInstance.acquireTokenRedirect({
        ...loginRequest,
        account: account ?? undefined,
      })

      return null
    }
  )

  return (
    <SBAsyncSelectProvider config={{ entities: config }}>
      <SBRM
        config={{
          acl: {
            hasAccess: (_) => true,
            permissionFromEntityAndAction: (_, __) => '',
          },
          entities: config,
          texts: {
            save: 'Enregistrer',
            close: 'Annuler',
            delete: 'Supprimer',
            actionButtonTooltipTitle: {
              addNew: 'Ajouter un(e) {{entity}}',
              update: 'Modifier {{entity}}',
              delete: 'Supprimer {{entity}}',
              duplicate: 'Dupliquer {{entity}}',
              view: 'Voir {{entity}}',
              comment: 'Commenter {{entity}}',
            },
            actionButtonLabel: {
              addNew: 'Ajouter',
              update: 'Modifier',
              delete: 'Supprimer',
              duplicate: 'Dupliquer',
              view: 'Voir',
              comment: 'Commenter',
            },
            drawerTitle: {
              addNew: 'Ajouter un(e) {{entity}}',
              createNew: 'Créer un nouveau {{entity}}',
              edit: 'Modifier {{entity}}',
              delete: 'Supprimer {{entity}}',
              comment: 'Commenter {{entity}}',
              view: 'Voir {{entity}}',
              upload: 'Téléverser {{entity}}',
              duplicate: 'Dupliquer {{entity}}',
              assign: 'Assigner {{entity}}',
              invite: 'Inviter {{entity}}',
              cancel: 'Annuler {{entity}}',
            },
          },
        }}
        fireSuccess={() => message.success(DEFAULT_SUCCESS)}
        fireError={() => {
          message.error(DEFAULT_ERROR)
        }}
      >
        <Outlet />
      </SBRM>
    </SBAsyncSelectProvider>
  )
}

export default App
